import { render, staticRenderFns } from "./ReviewStatusLabel.vue?vue&type=template&id=8423a188"
import script from "./ReviewStatusLabel.vue?vue&type=script&lang=ts"
export * from "./ReviewStatusLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports